export function buildErrorArray(error) {

    const isValidationError = (error) => {
        return error.response && 
                error.response.data &&
                error.response.data.validationErrors && 
                Array.isArray(error.response.data.validationErrors);
    }
    
    const isThrownError = (error) => {
        return error.response && 
                error.response.data &&
                error.response.data.exceptionMessage;
    }
    
    const handleValidationError = (error) => {
        return error.response.data.validationErrors;
    }
    
    const handleThrownError = (error) => {
        
        const errorArray = [{
            defaultMessage: error.response.data.exceptionMessage
        }];
    
        return errorArray;
    }
    
    const handleUnknownError = (error) => {
        
        const errorArray = [{
            defaultMessage: "Unknown error occured. Check console."
        }];
    
        console.error(error);

        return errorArray;
    }

    if (isValidationError(error)) {
        return handleValidationError(error);
    } else if(isThrownError(error)) {
        return handleThrownError(error);
    } else {
        return handleUnknownError(error);
    }

}